<app-closeable-dialog-title
  (maximizedChanged)="toggleMaximize($event)"
  [title]=" isUpdate() ? 'Update research paper' : 'Create research paper' ">
</app-closeable-dialog-title>

<mat-dialog-content class="maximize">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedIndexChange)="selectedTabIndex =$event">
    <mat-tab label="Single Create" [formGroup]="researchPaperForm">
      <mat-form-field appearance="fill">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title"/>
        @if (researchPaperForm.get('title')?.hasError('required')) {
          <mat-error>
            Title is required.
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Abstract Text</mat-label>
        <textarea matInput formControlName="abstractText"></textarea>
        @if (researchPaperForm.get('abstractText')?.hasError('required')) {
          <mat-error>
            Abstract Text is required.
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Venue</mat-label>
        <input matInput formControlName="venue"/>
        @if (researchPaperForm.get('venue')?.hasError('required')) {
          <mat-error>
            Venue is required.
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Authors</mat-label>
        <input matInput formControlName="authors"/>
        @if (researchPaperForm.get('authors')?.hasError('required')) {
          <mat-error>
            Authors are required.
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Year</mat-label>
        <input matInput formControlName="year" type="number"/>
        @if (researchPaperForm.get('year')?.hasError('required')) {
          <mat-error>
            Year is required.
          </mat-error>
        }
        @if (researchPaperForm.get('year')?.hasError('invalidYear')) {
          <mat-error>
            Year is invalid.
          </mat-error>
        }
      </mat-form-field>

      <div class="form-row">
        <mat-form-field appearance="fill">
          <mat-label>Reference Count</mat-label>
          <input matInput formControlName="referenceCount" type="number"/>
          @if (researchPaperForm.get('referenceCount')?.hasError('min')) {
            <mat-error>
              Reference Count must be a positive number.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Citation Count</mat-label>
          <input matInput formControlName="citationCount" type="number"/>
          @if (researchPaperForm.get('citationCount')?.hasError('min')) {
            <mat-error>
              Citation Count must be a positive number.
            </mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field appearance="fill">
        <mat-label>URL</mat-label>
        <input matInput formControlName="url" type="url"/>
        @if (researchPaperForm.get('url')?.hasError('pattern')) {
          <mat-error>
            URL is invalid.
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>PDF URL</mat-label>
        <input matInput formControlName="pdfUrl" type="url"/>
        @if (researchPaperForm.get('pdfUrl')?.hasError('pattern')) {
          <mat-error>
            PDF URL is invalid.
          </mat-error>
        }
      </mat-form-field>

      <div class="form-row">
        <mat-form-field appearance="fill">
          <mat-label>Semantic Scholar ID</mat-label>
          <input matInput formControlName="semanticScholarId"/>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>DOI</mat-label>
          <input matInput formControlName="doi"/>
          @if (researchPaperForm.get('doi')?.hasError('required')) {
            <mat-error>
              DOI is required.
            </mat-error>
          }
          @if (researchPaperForm.get('doi')?.hasError('invalidDOI')) {
            <mat-error>
              DOI is invalid.
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="fill">
          <mat-label>Corpus ID</mat-label>
          <input matInput formControlName="corpusId"/>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>MAG ID</mat-label>
          <input matInput formControlName="magId"/>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="fill">
          <mat-label>PubMed ID</mat-label>
          <input matInput formControlName="pubMedId"/>
        </mat-form-field>
        <mat-checkbox formControlName="isOpenAccess">Is Open Access</mat-checkbox>
      </div>

      <div
        class="drop-zone"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
        (click)="triggerFileInput()"
      >
        <p>Drag and drop Paper PDF here or click to select Paper</p>
        <input #fileInput type="file" multiple (change)="onFileSelected($event)" hidden>
      </div>
      @if (uploadedFile) {
        <p>Selected paper: {{ uploadedFile.name }}</p>
      }

    </mat-tab>
    <mat-tab label="Buld Upload">
      <h3>CSV</h3>
      <p>
        Please ensure your CSV file follows the exact format below to properly
      </p>
      <ul>
        <li><strong>title</strong> – Mandatory (cannot be blank)</li>
        <li><strong>abstractText</strong> – Mandatory (cannot be blank)</li>
        <li><strong>venue</strong> – Mandatory (cannot be blank)</li>
        <li><strong>authors</strong> – Mandatory (cannot be blank)</li>
        <li><strong>year</strong> – Mandatory (cannot be blank)</li>
        <li><strong>url</strong> – Optional</li>
        <li><strong>pdfName</strong> – Optional</li>
        <li>
          <strong>passedScreeningOne</strong> – Optional (Boolean value)
        </li>
        <li>
          <strong>passedScreeningTwo</strong> – Optional (Boolean value)
        </li>
        <li>
          <strong>doi</strong> – Mandatory (cannot be null and must follow a valid DOI format)
        </li>
      </ul>
      <p><em>Example CSV row:</em></p>
      <pre>
    title,abstractText,venue,authors,year,url,pdfName,passedScreeningOne,passedScreeningTwo,doi
    "Title","This is a Abstract","Journal","Alice, Bob","2025","","",true,false,"10.1234/journal5678"
    </pre>
      <div
        class="drop-zone"
        (drop)="onDropCSV($event)"
        (dragover)="onDragOver($event)"
        (click)="triggerCSVFileInput()"
      >
        <p>Drag and drop Paper CSV here or click to select CSV</p>
        <input #csvFileInput type="file" multiple (change)="onCSVFileSelected($event)" hidden>
      </div>
      @if (uploadedCSVFile) {
        <p>Selected csv: {{ uploadedCSVFile.name }}</p>
      }
      <h3>PDFs</h3>
      <div
        class="drop-zone"
        (drop)="onDropFiles($event)"
        (dragover)="onDragOver($event)"
        (click)="triggerFilesInput()"
      >
        <p>Drag and drop pdfs here or click to select pdfs</p>
        <input #filesInput type="file" multiple (change)="onFilesSelected($event)" hidden>
      </div>
      @if (uploadedPDFFiles) {
        @for (file of uploadedPDFFiles; track $index) {
          <div class="file-item">
            <p>{{ $index + 1 }}. {{ file.name }}</p>
            <button class="remove-btn" mat-icon-button (click)="removePDFFile($index)" aria-label="Delete file">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
      }
    </mat-tab>
  </mat-tab-group>


</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button class="save-btn" (click)="save()" [disabled]="!formIsValid()">
    <mat-icon>save</mat-icon>
    {{ isUpdate() ? 'Update' : 'Create' }}
  </button>
</mat-dialog-actions>
